import React from 'react';
import { MainReportDescription, ReportTitle, ReportInfo, ReportInfoTitle, ReportInfoData } from './ReportDescription.style';

const ReportDescription = (props) => {
  return (
    <MainReportDescription style={{height: props.he}}>
      <ReportTitle>{ props.info.title.toUpperCase() }</ReportTitle>
      <ReportInfo>
        <ReportInfoTitle>
          { props.info.commentsnumber }
          { props.info.commentsnumberString ? <div>{props.info.commentsnumberString}</div> : ''}
        </ReportInfoTitle>
        { props.info.socialdata ? <ReportInfoData>{ props.info.socialdata }</ReportInfoData> : ''}
      </ReportInfo>
    </MainReportDescription>
  );
}

export default ReportDescription;
